"use client";

import { Button } from "@mui/material";
import { WelcomePanel as WelcomePanelUI } from "@/ui";
import { DASHBOARD_FOCUS, PLAN_TYPES, Routes, USER_ROLES } from "@lib/enums";
import { useSettingsDialog } from "@lib/settings/SettingsDialogContext";
import content from "./content";

export default function WelcomePanel({ plan, recruiter, changeRoute, focus }) {
  const { title, subtitle, button, badgeIcon, badgeText } = content(
    recruiter,
    focus,
  );
  const createRoute =
    focus === DASHBOARD_FOCUS.SUBMISSIONS
      ? Routes.SUBMISSION_CREATE
      : Routes.FLOAT_CREATE;
  const { openSettings } = useSettingsDialog();

  const credits = recruiter?.user?.credits ?? 0;
  const planName = plan?.type;
  const isTrial = plan?.type === PLAN_TYPES.TRIAL;

  const role = recruiter?.role;
  const teamLabel =
    role === USER_ROLES.TEAM_ADMIN
      ? "Team admin"
      : role === USER_ROLES.MEMBER
        ? "Team member"
        : null;

  const label = isTrial
    ? `${credits} credit${credits === 1 ? "" : "s"} left`
    : `${planName} account`;

  return (
    <WelcomePanelUI
      label={label}
      secondLabel={teamLabel ?? undefined}
      heading={title}
      description={subtitle}
      action={
        <Button
          variant="contained"
          color="secondary"
          onClick={(e) => {
            e.preventDefault();
            changeRoute(createRoute);
          }}
        >
          {button}
        </Button>
      }
      profile={{
        avatar: recruiter?.photo_url
          ? <img src={recruiter.photo_url} alt={recruiter?.user?.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          : undefined,
        name: recruiter?.user?.name ?? "",
        company: recruiter?.company,
        jobTitle: recruiter?.job_title,
        badge: badgeText,
        badgeIcon,
        settingsLinkText: "Update your settings",
        onSettingsClick: openSettings,
      }}
    />
  );
}
